<div class="ops-create-company-container">
  <div class="border-auth-container">
    <div class="login-card">
      <h1 class="title">{{ 'organisation.createOrganisation' | translate }}</h1>
      <div class="login-form">
        <!-- <span
          >Welcome! Your account is verified and ready. Let's create your
          organisation. Fill in the form below to ensure accurate budget and
          cost tracking.</span
        >
        <br /> -->
        <ops-input
          (validationError)="onErrorHandler($event, 'name')"
          label="{{ 'organisation.organisationName' | translate }}"
          formName="selectedCompany.name"
          [value]="selectedCompany.name"
          (changed)="onInputChange($event, 'name')"
          type="text"
          mandatory="true"
        ></ops-input>

        <div class="nfut-container overflow-visible">
          <ops-select
            [options]="monthOptions"
            [defaultSelected]="selectedCompany.fiscalYearStartMonth"
            [formName]="selectedCompany.fiscalYearStartMonth"
            mandatory="true"
            label="{{ 'organisation.fiscalYearStartMonth' | translate }}"
            (changed)="onInputChange($event, 'fiscalYearStartMonth')"
          ></ops-select>

          <ops-select
            mandatory="true"
            [options]="dayOptions"
            [defaultSelected]="selectedCompany.fiscalYearStartDay"
            [formName]="selectedCompany.fiscalYearStartDay"
            label="{{ 'organisation.fiscalYearStartDay' | translate }}"
            (changed)="onInputChange($event, 'fiscalYearStartDay')"
          ></ops-select>
        </div>

        <div class="nfut-container overflow-visible">
          <!-- <ops-calendar
            label="Active Since *"
            (dateChanged)="updateDateOfEstablishment($event)"
            formName="selectedCompany.dateOfEstablishment"
            [date]="selectedCompany.dateOfEstablishment"
          ></ops-calendar> -->

          <ops-select
            [options]="yearsOptions"
            [defaultSelected]="defaultSelectedYear"
            [formName]="defaultSelectedYear"
            mandatory="true"
            label="{{ 'organisation.activeSince' | translate }}"
            (changed)="onInputYearChange($event)"
          ></ops-select>

          <ops-select
            rotateDropdownDirection="'true'"
            [options]="mainCurrencies"
            [defaultSelected]="selectedCompany.baseCurrencyCode"
            [formName]="selectedCompany.baseCurrencyCode"
            mandatory="true"
            label="{{ 'organisation.mainCurrency' | translate }}"
            (changed)="onSelectChange($event, 'baseCurrencyCode')"
          ></ops-select>
        </div>

        <div class="warning-text">
          {{ 'welcome.mainCurrencyWarning' | translate }}
        </div>

        <button
          [disabled]="!isValidData"
          opsDebounceClick
          (debouncedClick)="saveChanges()"
          type="button"
          class="login-btn"
        >
          {{ 'organisation.createOrganisation' | translate }}
        </button>

        <button (click)="onCloseModal()" type="button" class="close-btn">
          {{ 'common.close' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
